"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M11.453 18.49a1.76 1.76 0 0 0 1.095 0 1.72 1.72 0 0 0 .497-.262 25.975 25.975 0 0 0 4.187-4.169c1.27-1.581 1.905-3.264 1.905-5.047 0-1.203-.216-2.26-.65-3.169-.433-.91-.99-1.67-1.67-2.282a6.887 6.887 0 0 0-2.293-1.377A7.412 7.412 0 0 0 12 1.725c-.833 0-1.674.153-2.524.459a6.887 6.887 0 0 0-2.294 1.377c-.68.612-1.236 1.373-1.67 2.282-.433.91-.65 1.966-.65 3.17 0 1.782.636 3.465 1.906 5.046a25.971 25.971 0 0 0 4.187 4.17c.154.115.32.202.498.26ZM12 10.61a2.137 2.137 0 1 0 0-4.274 2.137 2.137 0 0 0 0 4.274Z",
      clipRule: "evenodd"
    }), (0, _jsxRuntime.jsx)("path", {
      d: "M5.192 21.946c.22.22.489.329.808.329h12c.32 0 .589-.11.808-.33.22-.219.33-.488.33-.808 0-.319-.11-.588-.33-.808A1.097 1.097 0 0 0 18 20H6c-.32 0-.589.11-.808.33-.22.219-.33.488-.33.808 0 .319.11.588.33.808Z"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};